if (document.querySelector("#particles")) {
    (function fadeOutOnScroll() {
        (function fadeOutOnScroll() {
            var particleContainers = document.querySelectorAll("#particles");
            var counter = 0;
            particleContainers.forEach(function (particlesContainer) {
                // Determine the number of particles to create
                var numParticles = 10;
                if (counter === 1) {
                    numParticles = 40;
                }
                counter++;
                for (var i = 0; i < numParticles; i++) {
                    // Create a new particle element
                    var particle = document.createElement("div");
                    particle.classList.add("particle");
                    // Generate random values for the particle's styles
                    var left = Math.random() * 100;
                    var right = Math.random() * 100;
                    var top_1 = Math.random() * 100;
                    var bottom = Math.random() * 100;
                    var duration = Math.random() * 2 + 2; // Increase the speed by decreasing the duration
                    var delay = Math.random() * 10;
                    var size = Math.random() * 20 + 10;
                    var colorRange = ['#D4D4D8', '#A1A1AA', '#71717A', '#52525B', '#3F3F46'];
                    var color = colorRange[Math.floor(Math.random() * colorRange.length)];
                    // Set the particle's styles
                    particle.style.left = left + "%";
                    particle.style.right = right + "%";
                    particle.style.top = top_1 + "%";
                    particle.style.bottom = bottom + "%";
                    particle.style.width = size + "px";
                    particle.style.height = size + "px";
                    particle.style.backgroundColor = color;
                    particle.style.animationDuration = duration + "s";
                    particle.style.animationDelay = delay + "s";
                    // Add the particle to the container
                    particlesContainer.appendChild(particle);
                }
            });
            var scrollSections = document.querySelectorAll("div.scroll-cool-2");
            window.addEventListener("scroll", function () {
                // given to use by the browser
                var scrollPosition = window.pageYOffset;
                // for each span, we're doing something slightly different
                // so lets do a loop for each one
                scrollSections.forEach(function (section, index) {
                    var span = section.querySelector("span");
                    var spanAir = document.querySelector("span.air-scale");
                    // move each scroll position per span up by 2000px
                    // this gives us 2000px per text to play with
                    //@ts-ignore
                    var spanScrollPosition = scrollPosition - section.offsetTop;
                    // if we're above 1000px in each span's scroll
                    if (spanScrollPosition > 1000) {
                        // fade out, starting at 1 going to 0 opacity
                        // - 1000 as we need to factor it where we started
                        // 0.001 is just speed of opacity change
                        //@ts-ignore
                        span.style.opacity = 1 - ((spanScrollPosition - 1000) * 0.001);
                    }
                    else {
                        // 0.001 is just speed of opacity change
                        //@ts-ignore
                        span.style.opacity = spanScrollPosition * 0.001;
                    }
                    // -0.02 is speed of movement change
                    // minus as we're going up page as we scroll down
                    var y = spanScrollPosition * -0.02;
                    var x = spanScrollPosition * 0.02;
                    span.style.transform = "translate(0, " + y + "px)";
                    //@ts-ignore
                    spanAir.style.transform = "scale(" + x + ")";
                });
            });
            var bars = document.querySelectorAll('.bar');
            var airPollutionBar = document.querySelector('.bar-air-pollution');
            bars.forEach(function (bar) {
                bar.style.width = '0%';
            });
            function updateBarWidth() {
                bars.forEach(function (bar, index) {
                    var rect = bar.getBoundingClientRect();
                    var text = bar.previousElementSibling;
                    var dataValue = bar.getAttribute('data-value');
                    //@ts-ignore
                    var width = dataValue / 2.2 * 100;
                    //@ts-ignore
                    bar.isTransitioned = false;
                    if (rect.top >= 0 && rect.bottom <= window.innerHeight && rect.left >= 0 && rect.right <= window.innerWidth) {
                        setTimeout(function () {
                            bar.classList.add("expand");
                            //@ts-ignore
                            bar.style.width = width + "%";
                        }, index * 250);
                        setTimeout(function () {
                            //@ts-ignore
                            bar.querySelector("span").style.opacity = "1";
                        }, index * 500);
                    }
                    else {
                        //@ts-ignore
                        bar.style.width = '0%';
                        //@ts-ignore
                        text.style.opacity = '0';
                    }
                });
                bars.forEach(function (bar) {
                    var dataValue = bar.getAttribute('data-value');
                    //@ts-ignore
                    var width = dataValue / 2.2;
                    var intervalId = setInterval(function () {
                        var computedWidth = window.getComputedStyle(bar).width;
                        var floatComputedWidth = parseFloat(computedWidth.replace("px", ""));
                        //@ts-ignore
                        var expectedWidth = bar.offsetWidth * width;
                    }, 50);
                });
            }
            // only execute the function when the elements are in the viewport
            window.addEventListener('scroll', updateBarWidth);
            var barContainers = document.querySelectorAll('.pollution-container');
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        var barContainer = entry.target;
                        var pTag = barContainer.querySelector('p.bar-chart-sub-header');
                        pTag.classList.add('opacity-100');
                    }
                });
            });
            barContainers.forEach(function (barContainer) {
                observer.observe(barContainer);
            });
            var locationDropdown = document.querySelector("#location-dropdown");
            var particleContainer = document.querySelector("#particles-2");
            locationDropdown.addEventListener("change", function () {
                // Get the data-pollution value of the selected option
                //@ts-ignore
                var pollutionLevel = locationDropdown.selectedOptions[0].getAttribute("data-pollution");
                var pollutionLevelText = document.querySelector("#pollution-level-text");
                var pollution_text;
                //@ts-ignore
                if (event.target.value === "los-angeles") {
                    pollution_text = "This is the pollution in Los Angeles. Particulate concentrations reached 106 µg/m3 during the highest hour, a level that would be considered unhealthy.";
                    //@ts-ignore
                }
                else if (event.target.value === "new-york-city") {
                    pollution_text = "This is the pollution in New York City. Particulate concentrations reached 38 µg/m3 during the highest hour, a level that would be considered unhealthy for sensitive groups.";
                    //@ts-ignore
                }
                else if (event.target.value === "san-francisco") {
                    pollution_text = "This is the pollution in San Francisco. Particulate concentrations reached 30 µg/m3 during the highest hour, a level that would be considered unhealthy for sensitive groups.";
                }
                //@ts-ignore
                else if (event.target.value === "london") {
                    pollution_text = "This is the pollution in London. Particulate concentrations reached 80 µg/m3 during the highest hour, a level that would be considered unhealthy.";
                }
                //@ts-ignore
                else if (event.target.value === "mumbai") {
                    pollution_text = "This is the pollution in Mumbai. Particulate concentrations reached 320 µg/m3 during the highest hour, a level that would be considered hazardous.";
                }
                //@ts-ignore
                else if (event.target.value === "sydney") {
                    pollution_text = "Particulate concentrations reached 169 µg/m3 during the highest hour, a level that would be considered very unhealthy.";
                }
                pollutionLevelText.textContent = pollution_text;
                pollutionLevelText.classList.remove("hidden");
                while (particleContainer.firstChild) {
                    particleContainer.removeChild(particleContainer.firstChild);
                }
                // Create new .particle elements based on the data-pollution value
                // Create new .particle elements based on the data-pollution value
                for (var i = 0; i < pollutionLevel; i++) {
                    var particle = document.createElement("div");
                    particle.classList.add("particle-2");
                    particleContainer.appendChild(particle);
                    // Generate random values for the particle's styles
                    var left = Math.random() * 100;
                    var top_2 = Math.random() * 100;
                    var duration = Math.random() * 2 + 2; // Increase the speed by decreasing the duration
                    var delay = Math.random() * 10;
                    var size = Math.random() * 20 + 10;
                    var colorRange = ['#D4D4D8', '#A1A1AA', '#71717A', '#52525B', '#3F3F46'];
                    var color = colorRange[Math.floor(Math.random() * colorRange.length)];
                    // Assign the random values to the particle's styles
                    particle.style.left = left + "%";
                    particle.style.top = top_2 + "%";
                    particle.style.animationDuration = duration + "s";
                    particle.style.animationDelay = delay + "s";
                    particle.style.width = size + "px";
                    particle.style.height = size + "px";
                    particle.style.backgroundColor = color;
                }
            });
            var images = document.querySelectorAll("img.zoom-up");
            var textzoom = document.querySelectorAll("p.zoom-up");
            var update = function () {
                // find the middle point of the browser
                var midBrowser = window.innerHeight / 2;
                // loop over each image
                images.forEach(function (img) {
                    // get the 'rectangle' positions of each image
                    var _a = img.getBoundingClientRect(), top = _a.top, height = _a.height;
                    // find where the middle of the image is within the browser
                    var midImg = top + height / 2;
                    // compare the middle of browser to the middle of each image
                    var diff = midImg - midBrowser;
                    // work out a scale
                    // can't be larger than 100%
                    // 1000 is for how quickly to change scale
                    var scale = Math.min(0, -1.5 - diff / 1000);
                    // change the images
                    //@ts-ignore
                    img.style.transform = "scale(" + scale + ")";
                });
                textzoom.forEach(function (text) {
                    console.log(text);
                    console.log(textzoom);
                    // get the 'rectangle' positions of each text element
                    var _a = text.getBoundingClientRect(), top = _a.top, height = _a.height;
                    // find where the middle of the text element is within the browser
                    var midText = top + height / 2;
                    // compare the middle of browser to the middle of each text element
                    var diff = midText - midBrowser;
                    // work out a scale
                    // can't be larger than 100%
                    // 1000 is for how quickly to change scale
                    var scale2 = Math.min(200, 50 - diff / 100);
                    // change the text elements
                    //@ts-ignore
                    text.style.transform = "translateX(" + scale2 + "%)";
                });
            };
            // run on load
            update();
            // and on scroll
            window.addEventListener("scroll", function () {
                update();
            });
            // and on page resize
            window.addEventListener("resize", function () {
                update();
            });
        })();
    })();
}
